import { useQuery, type QueryKey } from '@tanstack/react-query';

import { api } from './client';

export interface AdminAction {
  id: string;
  actorUserId: string;
  actorEmail: string | null;
  impersonationActorId: string | null;
  actionKind: string;
  targetType: string;
  targetId: string | null;
  reason: string | null;
  metadata: Record<string, unknown>;
  ipAddress: string | null;
  userAgent: string | null;
  occurredAt: string;
}

export interface ImpersonationSession {
  id: string;
  actorUserId: string;
  impersonatedUserId: string;
  reason: string;
  startedAt: string;
  expiresAt: string;
  endedAt: string | null;
  endedReason: string | null;
  ipAddress: string | null;
}

export interface ListAuditQuery {
  limit?: number;
  offset?: number;
  actorUserId?: string;
  targetType?: string;
  targetId?: string;
  actionKind?: string;
  hideReads?: boolean;
  from?: string;
  until?: string;
}

function buildQS(q: ListAuditQuery): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v !== undefined && v !== '' && v !== false) sp.set(k, String(v));
  }
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

export function auditKey(query: ListAuditQuery = {}): QueryKey {
  return ['admin', 'audit', query];
}
export function impersonationsKey(): QueryKey {
  return ['admin', 'impersonations'];
}

export function useAuditActions(query: ListAuditQuery) {
  return useQuery({
    queryKey: auditKey(query),
    queryFn: () => api<{ total: number; items: AdminAction[] }>(`/api/admin/audit${buildQS(query)}`),
    placeholderData: (prev) => prev,
  });
}

export function useImpersonationSessions() {
  return useQuery({
    queryKey: impersonationsKey(),
    queryFn: () =>
      api<{ total: number; items: ImpersonationSession[] }>('/api/admin/audit/impersonations'),
  });
}
